import Backbone from 'backbone'
import tpl from './app-dev-info.mustache'
import { browserStorage } from './utils/localStorage'
import { popShow } from './manager/mall.event'

export var AppDevInfoView = Backbone.View.extend({
  tagName: 'div',
  className: 'dev-info',
  template: tpl,

  initialize: function () {
    // this.model.off()
    this.model.on('change', this.render, this)
    this.render()
  },
  events: {
    'click [data-err]': 'logPop',
    'click [data-close]': 'close',
  },
  logPop: function () {
    var msg = browserStorage.get('mall-errors') || ['없음']
    popShow({
      title: '로그 봅시다',
      message:
        '<textarea style="height: 233px;width: 353px;">' +
        msg.join('\n\n') +
        '</textarea>',
      onClose: function () {
        this.hide()
      },
    })
  },
  render: function () {
    var version = PKG_VER // 패키지 버전 롤업에서 치환
    var devInfo = {
      env: NODE_ENV,
      purchaseRemain: this.model.get('purchaseLimit'),
      pmangCash: this.model.get('pmangCash'),
      gameName: this.model.get('gameName'),
      version: version,
    }
    var rendered = this.template.render({
      version: version,
      devInfo: devInfo,
      when: BUILD_TIME,
    })

    this.$el.empty().append(rendered)

    return this
  },
  close: function () {
    $(this.el).hide()
  },
})
